import { render, staticRenderFns } from "./VideoWithDnD.vue?vue&type=template&id=ba54a03a&scoped=true&"
import script from "./VideoWithDnD.vue?vue&type=script&lang=ts&"
export * from "./VideoWithDnD.vue?vue&type=script&lang=ts&"
import style0 from "./VideoWithDnD.vue?vue&type=style&index=0&id=ba54a03a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba54a03a",
  null
  
)

export default component.exports